export class Permission {
    constructor(
      id,
      sku,
      description,
      deletedAt,
      category = 'GENERAL'
    ) {
        this.id = id;
        this.sku = sku;
        this.description = description;
        this.deletedAt = deletedAt;
        this.category = category || 'GENERAL';
    }
    static createFromResponseData(data) {
      return new Permission(
        data.id,
        data.sku,
        data.description,
        data.deletedAt,
        data.category
      );
    }
  };